import React, { useRef, useState } from "react";
import { Field, ErrorMessage, useFormikContext } from "formik";
import css from "./style.scss";
import classNames from "classnames";
import { formatPhoneLive } from "../../../../../data/user/constants";
import { debounce } from "lodash";
import SVG from 'components/base/SVG';
import Tooltip from "../../../../components/Tooltip";

const FormikText = ({
  name,
  label,
  placeholder = label,
  type = "text",
  required = false,
  numbers = false,
  decimal = false,
  phone = false,
  maxLength = null,
  validationPattern = null, // Optional additional pattern
  disabled = false,
  errors = {},
  touched = {},
  className,
  /** 
   * This is optional property to hide the error message  
   * Currently used in case of password field where we show custom error component
   * */
  hideErrorMsg,
  delayOnChangeValidation = 0,
  // Function call it with onchange value to get if we should avoid delay
  avoidDelay
}) => {
  const inputRef = useRef(null);
  const { setFieldValue, validateField, setFieldTouched } = useFormikContext();
   const [showPassword, setShowPassword] = useState(false);

  const isPassword = type === "password";

  const handleInputChange = (e) => {
    let value = e.target.value;
    const input = e.target;
    const cursorPosition = input.selectionStart;
    if (phone) {
      const formattedValue = formatPhoneLive(value);
      setFieldValue(name, formattedValue);
      requestAnimationFrame(() => {
        if (inputRef.current) {
          const diff = formattedValue.length - value.length;
          const newPos = cursorPosition + diff;
          inputRef.current.setSelectionRange(newPos, newPos);
        }
      });
      return;
    }

    // Apply numbers/decimal restrictions
    if (numbers || decimal) {
      if (numbers && !decimal) {
        if (value.startsWith("00")) value = value.replace(/^0+/, "0");
        value = value.replace(/\D/g, "");
      } else if (!numbers && decimal) {
        value = value.replace(/[^0-9.]/g, "");
        if (value.startsWith("00")) value = value.replace(/^0+/, "0");
        if (value.startsWith(".")) value = "0" + value;
        const parts = value.split(".");
        if (parts.length > 2) {
          value = parts[0] + "." + parts.slice(1).join("");
        }
        if (parts.length === 2) {
          parts[1] = parts[1].slice(0, 2);
          value = parts.join(".");
        }
      } else if (numbers && decimal) {
        value = value.replace(/[^0-9.]/g, "");
        if (value.startsWith("00")) value = value.replace(/^0+/, "0");
        if (value.startsWith(".")) value = "0" + value;
        const parts = value.split(".");
        if (parts.length > 2) {
          value = parts[0] + "." + parts.slice(1).join("");
        }
        if (parts.length === 2) {
          parts[1] = parts[1].slice(0, 2);
          value = parts.join(".");
        }
      }
    }

    // Apply custom validationPattern if provided (remove matching pattern)
    if (validationPattern) {
      value = value.replace(validationPattern, "");
    }

    // Apply maxLength
    if (maxLength && value.length > maxLength) {
      value = value.slice(0, maxLength);
    }

    if(delayOnChangeValidation){
      const ignoreDelay = avoidDelay && avoidDelay(name);
      if(ignoreDelay) setFieldValue(name, value)
      else{
        setFieldValue(name, value, false);
        delayedValidateField(name);
      }
    }
    else setFieldValue(name, value);
  };

  const delayedValidateField = debounce((name) => {
    validateField(name);
    setFieldTouched(name, true, false);
  }, delayOnChangeValidation);

  return (
    <div className={css.clsFormGroup}>
      <label
        className={classNames(
          css.clsFormLabel,
          errors[name] && touched[name] && css.text_danger
        )}
        htmlFor={name}
      >
        {label}
        {required && <span className={css.text_primary}>*</span>}
      </label>

      <Field name={name}>
        {({ field }) => (
           <div className={css.passwordWrapper}>
          <input
            {...field}
            id={name}
            type={isPassword && showPassword ? "text" : type}
            placeholder={placeholder}
            className={classNames(
              css.clsFormControl,
              className,
              errors[name] && touched[name] && css.clsBorderDanger,
              { 
                [css.disabled]: disabled,
                [css.passwordInput]: isPassword
              }
            )}
            disabled={disabled}
            maxLength={maxLength || undefined}
            onChange={handleInputChange}
            value={field.value != null ? field.value : ''}
            ref={inputRef}
          />

           {isPassword && (
              <button
                type="button"
                className={css.passwordToggle}
                onClick={() => setShowPassword((prev) => !prev)}
              >
                <Tooltip title=""
                  content={showPassword ? "Hide Password" :"Show Password"}
                  position="top"
                  bgColor="#128292"
                  xOffset={showPassword ? -4 : -1}
                  yOffset={-44}
                  arrowOffset={70}
                  >
                  {showPassword ? <SVG icon="eyeOn" height='20' width='20' /> : <SVG icon="eyeOff" height='20' width='20' /> }
                </Tooltip>
              </button>
            )}
            </div>
        )}
      </Field>
     {
      !hideErrorMsg && <ErrorMessage
        name={name}
        component="div"
        className={classNames(css.clsFormErrorText, css.text_danger)}
      />
     }
      
    </div>
  );
};

export default FormikText;